<section
    class="anc-detail-section"
    [class.anc-detail-section--divider]="divider()"
>
    <h4 class="anc-detail-section__title" *ngIf="title()" translate>
        {{ title() }}
    </h4>
    <div class="anc-detail-section__grid" [style.--anc-cols]="columns()">
        <ng-content></ng-content>
    </div>
</section>
